
        import {css} from 'lit-element';   
        export default css`:host .form-error{display:none;margin-top:4px;font-size:12px;color:var(--spectrum-semantic-negative-color-state-hover)}:host .form-error.error{display:block}`;
    